import ImpersonationApiKey from "./impersonationApiKey";
import ThrowsValidationError from "common/http/throwsValidationError";
import AdminHttpService from "admin/common/adminHttpService";

class ImpersonationService extends AdminHttpService {

    async listKeys(merchantId: string): Promise<ImpersonationApiKey[]> {
        const response = await this.getClient().get<ImpersonationApiKey[]>(`/settings/v1/merchants/${merchantId}/impersonation-keys`);
        return response.data;
    }
    
    @ThrowsValidationError()
    async createKey(merchantId: string, key: ImpersonationApiKey): Promise<CreatedImpersonationApiKey> {
        const response = await this.getClient().post<CreatedImpersonationApiKey>(`/settings/v1/merchants/${merchantId}/impersonation-keys`, 
            {
                name: key.name,
                notes: key.notes,
                userIdentifierType: key.userIdentifierType,
                tokenLifetimeInSeconds: key.tokenLifetimeInSeconds
            }
        );
        return response.data;
    }

    @ThrowsValidationError()
    async deleteKey(merchantId: string, key: ImpersonationApiKey): Promise<any> {
        await this.getClient().delete(`/settings/v1/merchants/${merchantId}/impersonation-keys/${key.id}`);
    }
}

export interface CreatedImpersonationApiKey extends ImpersonationApiKey {
    secret: string;
}

const impersonationService = new ImpersonationService();

export default impersonationService;